var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallXIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13965"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "9782d838133663839665943c222e67d6",
    d: "m12.168 11 3.58-3.572a.836.836 0 0 0-1.182-1.182l-3.572 3.58-3.571-3.585A.836.836 0 1 0 6.24 7.423L9.82 11l-3.58 3.567a.836.836 0 1 0 1.183 1.183l3.572-3.58 3.572 3.58a.836.836 0 1 0 1.182-1.182z",
    transform: "translate(-1.328 -.996)",
    style: {
      fill: "#c09260"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallXIc);
export default __webpack_public_path__ + "static/media/small_x_ic.b374987d0406646d346e8cec21c9e47c.svg";
export { ForwardRef as ReactComponent };